(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/bomben-xperten.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/bomben-xperten.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.BombenXperten = Backbone.Model.extend(
    {
      log: new svs.core.log.Logger('svs.tipset.models.BombenXperten'),

      defaults: {
        bombenSystem: [
          { size: 0 },
          { size: 24 },
          { size: 40 },
          { size: 60 },
          { size: 100 },
          { size: 150 },
          { size: 200 },
          { size: 300 },
          { size: 400 },
          { size: 500 }
        ],
        hasXpertValues: false,
        systemSize: 0,
        wager: undefined
      },

      url: function() {
        svs.events.publish('/loader/show');
        var newUrl =
          '/wager/xpertwagers/BOMBEN?systemSize=' +
          this.get('systemSize') +
          '&drawNumber=' +
          svs.tipset.collections.draws.getCurrentDraw().get('bombenDrawNum');

        return svs.core.jupiter.url() + newUrl;
      },

      setSystem: function(systemSize) {
        var noSystemIsSet = systemSize.size > 0;
        this.set('systemSize', systemSize.size, { silent: noSystemIsSet });
        this.set('hasXpertValues', noSystemIsSet, { silent: noSystemIsSet });

        if (systemSize.size > 0) {
          this.fetch({ error: this.errorHandler });
        }
      },

      errorHandler: function() {
        svs.events.publish('/loader/hide');
        svs.components.dialog.api.add(new svs.components.dialog.Confirm({
          branding: svs.components.dialog.branding.SPORT,
          icon: 'help-2',
          title: 'Det går inte spela Xperten just nu',
          actions: [
            {
              title: 'OK'
            }
          ]
        }));
      },

      reload: function() {
        if (this.get('hasXpertValues')) {
          this.fetch();
        }
      },

      getBombenWager: function() {
        var w = this.get('wager');
        var bombenWager = JSON.parse(JSON.stringify(w));

        bombenWager.bets[0].betAmountSalesGroup1 = svs.utils.format.CurrencyAsJupiterString(
          this.get('systemSize')
        );
        bombenWager.bets[0].numDraws = 1;
        bombenWager.bets[0].rowPriceMulti = 1;
        return bombenWager;
      },

      parse: function(response) {
        if (response.error) {
          svs.events.publish('/loader/hide');
          svs.components.dialog.api.add(new svs.components.dialog.Confirm({
            branding: svs.components.dialog.branding.SPORT,
            icon: 'help-2',
            title: 'Det går inte spela Xperten just nu',
            actions: [
              {
                title: 'OK'
              }
            ]
          }));
          this.reset();
        } else {
          svs.events.publish('/loader/hide');
          this.set('wager', response.wager, { silent: true });
          return response.wager.bets[0].expertenBoardData;
        }
      },

      getXpertenData: function(index) {
        return this.get('eventResults')[index];
      },

      bombenDone: function() {
        if (this.get('systemSize') > 0) {
          this.trigger('bombenSet');
        } else {
          this.trigger('bombenRemoved');
        }
      },

      reset: function() {
        this.set('systemSize', 0, { silent: true });
        this.set('hasXpertValues', false);
        this.unset('eventResult', { silent: true });
        this.unset('wager', { silent: true });
        this.trigger('bombenRemoved');
      }
    },
    {
      type: 'svs.bomben.models.Xperten'
    }
  );
})(Backbone, _, svs);

 })(window);